import { useState, useEffect } from 'react'
import { Spinner, apiClient } from '../utils/helpers';
import {
  ArrowPathIcon
} from '@heroicons/react/20/solid';
import VerifyPhone from '../components/VerifyPhone'
import VerifyEmail from '../components/VerifyEmail'
import MyBookingItem from '../components/MyBookings/MyBookingItem'
import { useTranslation } from 'react-i18next';

export default function MyBookings(props) {

  const { t } = useTranslation();
  const [loading,setLoading] = useState();
  const [otpVerified, setOtpVerified] = useState(false);
  const [bookings,setBookings] = useState();
  const [,setError] = useState();
  const [phone,setPhone] = useState();
  const [email,setEmail] = useState();
  const [customer,setCustomer] = useState();

  useEffect(() => {
    if(otpVerified === true) {
      loadUserBookings()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[otpVerified]);  

  async function loadUserBookings() {  

    setLoading(true) 

    // IMRPOVE THIS SO IT ONLY NEEDS TO QUERY 1 KEY
    apiClient.post(`/api/get_user_bookings`,{
      country: phone ? phone.country : null,
      phone: phone ? phone.number : null,
      email: email ? email : null
    })
    .catch(function(err){
      setError(err.response.data.message)
    })
    .then((response) => {
      
      setCustomer(response.data.customer);
      setBookings(response.data.bookings);

    })
    .finally(() => {
      setLoading(false)
    })
    
  } 
  
  return (
    <div className="pt-12">

      <div className="flex flex-col max-w-screen-md mx-auto my-8">

        <div className="p-5 px-8 bg-base border border-gray-800 rounded-xl relative">          
          {
            !otpVerified &&
            <div className="flex flex-col gap-1">
              <h3 className="font-bold text-gold">{t('login_to_see_bookings')}</h3>
              <VerifyPhone setPhone={setPhone} checkUser={true} setOtpVerified={setOtpVerified}/>
              <span className="my-3 font-bold text-gold">&mdash; {t('or')} &mdash;</span>
              <VerifyEmail setEmail={setEmail} checkUser={true} setOtpVerified={setOtpVerified}/>
            </div>          
          }
          {
            otpVerified && customer &&
            <div>
              <div className="flex justify-between">
                <div>
                  <h3 className="font-bold text-gold text-xl">{t('welcome_back',{fname:customer.first_name,lname:customer.last_name,gender: customer.gender === 'M' ? t('mr') : t('ms')})}</h3>
                  <p>
                    {t('find_your_bookings_below')}
                  </p>
                </div>
                <button className="hover:text-green-500" onClick={() => loadUserBookings() }>
                  <ArrowPathIcon className="w-5 h-5"/>
                </button>
            </div>
              {
                loading &&
                <>
                  <div className="flex gap-x-3 text-red-500 my-3">
                    <Spinner />  Loading Your Bookings...
                  </div>
                </>
              }
              {
                bookings &&
                <div className="flex flex-col gap-3 divide-y divide-gray-800 my-5 border-t border-gray-800">
                {
                  bookings.map((b,i) => (
                    <MyBookingItem booking={b} key={i}/>                  
                  ))
                }
                </div>
              }              
            </div>
          }
          

        </div>        

      </div>

    </div>
  );
}